import { cn } from '@/lib/utils';
import { Check, Minus } from 'lucide-react';

export interface FichaCompletenessFlags {
    hasEditorial?: boolean;
    hasVeredicto?: boolean;
    hasSeo?: boolean;
    hasDescripcion?: boolean;
    completeness?: number;
}

const ITEMS: Array<{ key: keyof FichaCompletenessFlags; label: string }> = [
    { key: 'hasEditorial', label: 'Criterio' },
    { key: 'hasVeredicto', label: 'Veredicto' },
    { key: 'hasSeo', label: 'SEO' },
    { key: 'hasDescripcion', label: 'Descripción' },
];

export function FichaCompleteness({
    flags,
    compact = false,
}: {
    flags: FichaCompletenessFlags;
    compact?: boolean;
}) {
    const score = flags.completeness
        ?? ITEMS.filter((i) => flags[i.key]).length;
    return (
        <div className={cn('flex flex-wrap items-center gap-1.5', compact && 'gap-1')}>
            <span
                className={cn(
                    'tabular-nums font-semibold',
                    compact ? 'text-[11px]' : 'text-xs',
                    score >= 4 ? 'text-emerald-600 dark:text-emerald-400' : 'text-amber-700 dark:text-amber-400',
                )}
            >
                {score}/4
            </span>
            {ITEMS.map((item) => {
                const on = Boolean(flags[item.key]);
                return (
                    <span
                        key={item.key}
                        title={item.label}
                        className={cn(
                            'inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5',
                            compact ? 'text-[10px]' : 'text-[11px]',
                            on
                                ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-800 dark:text-emerald-300'
                                : 'border-border bg-muted/40 text-muted-foreground',
                        )}
                    >
                        {on ? <Check className="h-3 w-3" /> : <Minus className="h-3 w-3" />}
                        {item.label}
                    </span>
                );
            })}
        </div>
    );
}
